var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlossaryDropdownButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3576 8.04504L10.4201 13.9825C10.3649 14.0377 10.2994 14.0815 10.2274 14.1114C10.1553 14.1413 10.078 14.1567 9.99999 14.1567C9.92197 14.1567 9.8447 14.1413 9.77262 14.1114C9.70054 14.0815 9.63506 14.0377 9.57992 13.9825L3.64242 8.04504C3.531 7.93363 3.46841 7.78252 3.46841 7.62496C3.46841 7.4674 3.531 7.3163 3.64242 7.20489C3.75383 7.09347 3.90493 7.03088 4.06249 7.03088C4.22005 7.03088 4.37116 7.09347 4.48257 7.20489L9.99999 12.723L15.5174 7.20489C15.5726 7.14972 15.6381 7.10596 15.7101 7.07611C15.7822 7.04625 15.8595 7.03088 15.9375 7.03088C16.0155 7.03088 16.0928 7.04625 16.1648 7.07611C16.2369 7.10596 16.3024 7.14972 16.3576 7.20489C16.4127 7.26005 16.4565 7.32554 16.4864 7.39762C16.5162 7.4697 16.5316 7.54695 16.5316 7.62496C16.5316 7.70298 16.5162 7.78023 16.4864 7.85231C16.4565 7.92439 16.4127 7.98988 16.3576 8.04504Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlossaryDropdownButton);
export default __webpack_public_path__ + "static/media/GlossaryDropdownButton.6872c9d17ddb94a540245fecb484c815.svg";
export { ForwardRef as ReactComponent };